<div style="padding: 24px;">
  <h5 mat-dialog-title class="text-center">Editar país</h5>
  <div mat-dialog-content>
    <!--begin::Form-->
    <form class="form" [formGroup]="editCountryForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
      <div class="form-group">
        <br-alert *ngIf="showAlert"></br-alert>
        <p><strong>ID: </strong>{{countryData.id}}</p>
        <p><strong>Fecha de creación: </strong>{{countryData.createdAt | date: 'MMMM d, y'}}</p>
        <mat-form-field class="w-100">
          <mat-label>País</mat-label>
          <input matInput type="text"
                 formControlName="country" autocomplete="off"/>
          <mat-error *ngIf="isControlHasError('country', 'required')">
            <strong>Campo requerido</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-100">
          <mat-label>Código País</mat-label>
          <input matInput type="text"
                 formControlName="countryCod" autocomplete="off"/>
          <mat-error *ngIf="isControlHasError('countryCod', 'required')">
            <strong>Campo requerido</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </form>
    <!--end::Form-->
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick(false)">Cerrar</button>
    <button mat-button cdkFocusInitial (click)="submit(editCountryForm)">Guardar</button>
  </div>
</div>
